
export const mockToken = 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9'
    + '.eyJhdWQiOiI5MzlkZjUxNi02MzA3LTQ5Y2QtOTc1My0zMWE3MzdkOTFhMGYiLCJqdGkiOiIyNDEyMTllNWQ0NTlkYTY5MmZiZDQxZGZkOTg3MTU3NDU5MTE1MWJh'
    + 'NDUzM2FkZTVhZWUzNWIxOTM3OTgyYjc0ZjEzYmI0NDliMjc1ZjYxNiIsImlhdCI6MTYyNzYzNzc0MiwibmJmIjoxNjI3NjM3NzQyLCJleHAiOjE2NTkxNzM3NDIs'
    + 'InN1YiI6IjIwIiwic2NvcGVzIjpbXX0.VYr834D-aRhwkBNYqvkODTsh2FxuAisM4Ggx_U5a-l9hm7Ljg8z5Gbzgdoo-FGoJRkgAOhaiBAzdv2AdZ58hvA';

export const PRE_REG_API = 'PRE_REG_API';


/**
 * The type of (redux) action to set the default page index of
 * {@link WelcomePageLists}.
 *
 * {
 *     type: SET_USER_DETAILS,
 *     userd: ?Object
 * }.
 */
export const SET_USER_DETAILS = 'SET_USER_DETAILS';

/**
 * The type of (redux) action to set the default page index of
 * {@link WelcomePageLists}.
 *
 * {
 *     type: SET_VOLUME_CHANGE,
 *     userd: ?Object
 * }.
 */
export const SET_VOLUME_CHANGE = 'SET_VOLUME_CHANGE';

/**
 * The type of (redux) action to set the default page index of
 * {@link WelcomePageLists}.
 *
 * {
 *     type: SET_VOLUME_CHANGE,
 *     userd: ?Object
 * }.
 */
export const SET_OCCURANCE_ID = 'SET_OCCURANCE_ID';

/**
 * The type of (redux) action to set the default page index of
 * {@link WelcomePageLists}.
 *
 * {
 *     type: SET_VOLUME_CHANGE,
 *     userd: ?Object
 * }.
 */
export const SET_ACCESS_TOKEN_NATIVE = 'SET_ACCESS_TOKEN_NATIVE';


export const SET_PASSWORD_FORM_NATIVE = 'SET_PASSWORD_FORM_NATIVE';


export const SET_ATTENDANCE_API = 'SET_ATTENDANCE_API';

export const SET_VOICE_COMMAND_STRING = 'SET_VOICE_COMMAND_STRING';

export const INVALID_MEETING_JSON = 'INVALID_MEETING_JSON';

export const SEND_AUTO_RECORD_COMMAND = 'SEND_AUTO_RECORD_COMMAND';

export const AUTO_RECORD_STOP = 'AUTO_RECORD_STOP';

export const IS_RECORDING_AND_LIVESTREAMING_ON = 'IS_RECORDING_AND_LIVESTREAMING_ON';


/**
 * The type of (redux) action to set the default page index of
 * {@link Conferece}.
 *
 * {
 *     type: SET_AUTO_PASSWORD,
 *     md5password: ?Object
 * }.
 */
export const SET_AUTO_PASSWORD = 'SET_AUTO_PASSWORD';

export const SET_DESKTOP_APP = 'SET_DESKTOP_APP';

export const SET_IS_SWITCHING_BREAKOUT_ROOM = 'SET_IS_SWITCHING_BREAKOUT_ROOM';

export const SET_IS_SWITCHING_TO_MAIN_ROOM = 'SET_IS_SWITCHING_TO_MAIN_ROOM';

export const FAKE_PARTICPANT_JOINED = 'FAKE_PARTICPANT_JOINED';

export const FAKE_PARTICPANT_LEFT = 'FAKE_PARTICPANT_LEFT';
